import fn from "@/utils/fn";

export const columnsList = [
  {
    title: "操作类型",
    key: "type_ch",
    align: "center",
  },
  {
    title: "IP地址",
    key: "ip",
    align: "center",
  },
  {
    title: "操作者",
    key: "username",
    align: "center",
  },
  {
    title: "操作时间",
    key: "update_time",
    align: "center",
  },
];

export const timeOption = {
  shortcuts: [
    {
      text: "最近1周",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        return [start, end];
      },
    },
    {
      text: "最近1月",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        return [start, end];
      },
    },
    {
      text: "最近1年",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
        return [start, end];
      },
    },
  ],
};
